import React from 'react';
import { Box } from '@mui/material';
import { FaHouseDamage } from 'react-icons/fa';
import {
    Navigate,
    Route,
    Routes,
    useLocation,
    useNavigate
} from 'react-router-dom';
import Header from '../../Common/Header/Header';
import ChartsContainer from '../Common/ChartsContainer';
import HomelessWrapper from './Homeless';

const menus = [
    {
        title: 'Situação de Rua',
        path: '/governanceroom/dashboardunifiedregistry/street-situation/homeless',
        icon: <FaHouseDamage style={{ marginRight: '5px' }} />
    }
];

const titleMap = {
    '/governanceroom/dashboardunifiedregistry/street-situation/homeless':
        'Perfil das Pessoas em Situação de Rua'
};

const StreetSituation = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const handleHomeClick = () => {
        navigate('/governanceroom/dashboardunifiedregistry');
    };

    return (
        <Box>
            <Header menus={menus} onHomeClick={handleHomeClick} />
            <Box className="content">
                <ChartsContainer
                    title={titleMap[location.pathname]}
                    className="services-container-dashboards"
                >
                    <Routes>
                        <Route
                            path="/"
                            element={<Navigate to="homeless" />}
                        />

                        <Route
                            path="homeless"
                            element={<HomelessWrapper />}
                        />
                    </Routes>
                </ChartsContainer>
            </Box>
        </Box>
    );
};

export default StreetSituation;
